import { Tabs as BaseTabs } from "antd";
import styled, { css } from "styled-components";

import color from "../_style/color";

const variants = {
  basic: css``,
  "full-width": css`
    .ant-tabs-nav {
      margin: 0;
    }

    .ant-tabs-nav-list {
      width: 100%;
    }
    .ant-tabs-tab {
      margin-right: 0px !important;
      width: 100%;
      text-align: center;
      display: block;
      font-size: 16px;
      :hover {
        color: ${color.highempahis};
      }
    }

    .ant-tabs-nav .ant-tabs-nav-list {
      border: 1px solid ${color.whiteSmoke};
    }

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,
    .ant-tabs-tab .ant-tabs-tab-active {
      color: ${color.highempahis};
    }
  `,
};

const Tabs = styled(BaseTabs).attrs((props) => ({
  variant: props.variant || "basic",
}))`
  ${({ variant }) => variants[variant]}
`;

export default Tabs;
